import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AIAssistant from "@/components/AIAssistant";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import SpotsPage from "@/pages/SpotsPage";
import SpotDetail from "@/pages/SpotDetail";
import KitsPage from "@/pages/KitsPage";
import LicensePage from "@/pages/LicensePage";
import CGUPage from "@/pages/CGUPage";
import ContactPage from "@/pages/ContactPage";
import CatchLogPage from "@/pages/CatchLogPage";
import AdminMessagesPage from "@/pages/AdminMessagesPage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-background">
      <BrowserRouter>
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/spots" element={<SpotsPage />} />
            <Route path="/spots/:id" element={<SpotDetail />} />
            <Route path="/equipement" element={<KitsPage />} />
            <Route path="/carte-de-peche" element={<LicensePage />} />
            <Route path="/cgu" element={<CGUPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/carnet" element={<CatchLogPage />} />
            <Route path="/admin/messages" element={<AdminMessagesPage />} />
          </Routes>
        </main>
        <Footer />
        <AIAssistant />
      </BrowserRouter>
      <Toaster position="bottom-left" />
    </div>
  );
}

export default App;
